// Constants in support of ImplicitBoolean
//
export const Operation = {
  UNION: 0,
  INTERSECTION: 1,
  DIFFERENCE: 2,
};

export default {
  Operation,
};
